function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import ServiceFactory from "../../service";
import { loadBrandKit } from "../../functions/brand-kit";

// Content Hub Edit Mode + Smart Resize (CONTENT_HUB_CANVAS_VS_AIR_2026-10-01, Tier 1).
// Works on any image asset from any source (Shopify, feed, ERP, custom API, generated, upload).
// The App runs content_image_edit_agent / content_resize_agent (credits are charged at enqueue) and
// records every outcome on /content/assets/{id}/edits, which stacks a new version under the family.
// House rules: kit tokens only, no credit mentions anywhere in the UX (DS 2026-10-01); credits are still recorded on the job.

function svc(api) {
  const S = ServiceFactory.getType(api, "product");
  return new S();
}
async function safe(promise, fallback) {
  try {
    return (await promise) || fallback;
  } catch (e) {
    return fallback;
  }
}
function toast(msg) {
  const t = document.querySelector("paper-toast");
  if (t) t.show(msg);
}
const AI_CREDITS = 6; // one gpt-image-2 edit; one Smart Resize set
const MECHANICAL = new Set(["crop", "flip", "rotate", "upscale", "resize", "overlay_logo", "badge"]);
export const TOOLS = [["prompt_edit", "Prompt edit", "Describe the change. Draw a box to limit it to one area.", true], ["erase", "Erase", "Draw a box over what should go. The scene fills in behind it.", true], ["remove_background", "Remove background", "Transparent, white or a brand color.", true], ["extend", "Extend", "Grow the canvas to a new aspect. The scene continues at the edges.", true], ["upscale", "Upscale", "2x, sharper for product page zoom.", false], ["crop", "Crop", "Draw a box, keep what is inside.", false], ["flip", "Flip", "Mirror horizontally or vertically.", false], ["rotate", "Rotate", "Quarter turns.", false], ["lift_subject", "Lift subject", "Cut the subject out, fill where it was, drop it where you draw.", true]];
export const CHANNELS = [["ig_square", "Instagram 1:1", 1080, 1080], ["ig_portrait", "Feed 4:5", 1080, 1350], ["story", "Reels / Stories 9:16", 1080, 1920], ["yt", "YouTube 16:9", 1920, 1080], ["ads", "Ads 1200x628", 1200, 628], ["email", "Email hero 1200x600", 1200, 600], ["pin", "Pinterest 2:3", 1000, 1500], ["pdp", "Product page 2048 square", 2048, 2048]];

// Tier 2 (2026-10-01): product edits (any catalog source; the agent routes by category) and brand-kit actions.
export const PRODUCT_TOOLS = [["variant_swap", "Swap color, material or variant", "From the product's own options."], ["place_in_context", "Place in context", "Scene presets for this category."], ["view_pack", "View pack", "Front, back, side, detail from one photo."], ["packshot", "Packshot", "White or brand background, centered."]];
export const BRAND_TOOLS = [["overlay_logo", "Add logo", "Brand kit logo, any corner."], ["brand_background", "Brand color background", "Cut out, placed on the accent color."], ["badge", "Sale badge", "Short text pill in brand colors."]];
const SCENES = [["", "Best for this product"], ["on_model", "On model"], ["flat_lay", "Flat lay"], ["desk", "Desk"], ["kitchen", "Kitchen"], ["shelf", "Shelf"], ["in_hand", "In hand"], ["room", "Room"], ["outdoor", "Outdoor"], ["lifestyle", "Lifestyle"], ["studio", "Studio"]];
const VIEWS = [["front", "Front"], ["back", "Back"], ["side", "Side"], ["three_quarter", "Three quarter"], ["top", "Top"], ["detail", "Detail"]];
const POSITIONS = [["bottom_right", "Bottom right"], ["bottom_left", "Bottom left"], ["top_right", "Top right"], ["top_left", "Top left"], ["center", "Center"]];
const PRODUCT_ACTIONS = new Set(PRODUCT_TOOLS.map(t => t[0]));
// Tile face per tool: material icon + short label (the full description shows under the image once a tool is picked).
const TILE = {
  prompt_edit: ["auto_fix_high", "Prompt"],
  erase: ["auto_fix_normal", "Erase"],
  remove_background: ["layers_clear", "Background"],
  extend: ["open_in_full", "Extend"],
  upscale: ["hd", "Upscale"],
  crop: ["crop", "Crop"],
  flip: ["flip", "Flip"],
  rotate: ["rotate_90_degrees_ccw", "Rotate"],
  lift_subject: ["pan_tool_alt", "Lift subject"],
  variant_swap: ["palette", "Swap variant"],
  place_in_context: ["chair", "In context"],
  view_pack: ["view_carousel", "View pack"],
  packshot: ["photo_camera", "Packshot"],
  overlay_logo: ["branding_watermark", "Logo"],
  brand_background: ["format_color_fill", "Brand color"],
  badge: ["sell", "Badge"]
};
function Tile({
  k,
  name,
  on,
  off,
  title,
  onClick
}) {
  const [icon, short] = TILE[k] || ["tune", name];
  return /*#__PURE__*/React.createElement("button", {
    className: "hub-edit-tile" + (on ? " on" : ""),
    disabled: off,
    title: title || name,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, icon), /*#__PURE__*/React.createElement("b", null, short));
}
const ASPECTS = [["1:1", "Square 1:1"], ["4:5", "Portrait 4:5"], ["3:4", "Portrait 3:4"], ["16:9", "Wide 16:9"], ["9:16", "Tall 9:16"], ["4:3", "Classic 4:3"]];
function clamp01(v) {
  return Math.max(0, Math.min(1, v));
}
function fmtWhen(d) {
  if (!d) return "";
  const t = new Date(d);
  return isNaN(t) ? "" : t.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric"
  });
}
function sourceLabel(s) {
  const m = {
    shopify: "Shopify",
    edit: "Edited",
    plunk_image: "Generated",
    manual: "Added",
    catalog: "Catalog",
    feed: "Feed",
    erp: "ERP",
    api: "API",
    upload: "Upload"
  };
  return m[s] || (s ? s.charAt(0).toUpperCase() + s.slice(1) : "Asset");
}

/** Resolve an asset row from an id or a URL (URL path registers or dedupes on content hash). */
export async function resolveAsset(assetOrUrl) {
  if (!assetOrUrl) return null;
  if (typeof assetOrUrl === "object" && assetOrUrl.id) return assetOrUrl;
  const url = typeof assetOrUrl === "string" ? assetOrUrl : assetOrUrl.url;
  return safe(svc("/content/assets").postAsync({
    kind: "image",
    url
  }), null);
}

/** Image with a drag-to-draw rectangle, in fractions of the image. */
export class RectCanvas extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      drag: null
    });
    // Fractions are measured against the rendered IMAGE, never the container: a letterboxed image would
    // otherwise shift every box (the first staging erase landed beside the logo instead of on it).
    _defineProperty(this, "frac", e => {
      const box = (this.img || this.el).getBoundingClientRect();
      return {
        x: clamp01((e.clientX - box.left) / box.width),
        y: clamp01((e.clientY - box.top) / box.height)
      };
    });
    _defineProperty(this, "down", e => {
      if (!this.props.enabled) return;
      e.preventDefault();
      this.setState({
        drag: {
          a: this.frac(e),
          b: this.frac(e)
        }
      });
    });
    _defineProperty(this, "move", e => {
      if (!this.state.drag) return;
      this.setState({
        drag: {
          ...this.state.drag,
          b: this.frac(e)
        }
      });
    });
    _defineProperty(this, "up", () => {
      const d = this.state.drag;
      if (!d) return;
      this.setState({
        drag: null
      });
      const x = Math.min(d.a.x, d.b.x),
        y = Math.min(d.a.y, d.b.y),
        w = Math.abs(d.a.x - d.b.x),
        h = Math.abs(d.a.y - d.b.y);
      if (w < 0.02 || h < 0.02) {
        this.props.onRect(null);
        return;
      }
      this.props.onRect({
        x: +x.toFixed(4),
        y: +y.toFixed(4),
        w: +w.toFixed(4),
        h: +h.toFixed(4)
      });
    });
  }
  render() {
    const {
      src,
      rect,
      enabled,
      checker
    } = this.props;
    const d = this.state.drag;
    const live = d ? {
      x: Math.min(d.a.x, d.b.x),
      y: Math.min(d.a.y, d.b.y),
      w: Math.abs(d.a.x - d.b.x),
      h: Math.abs(d.a.y - d.b.y)
    } : rect;
    return /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-stage-wrap"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-canvas" + (enabled ? " draw" : "") + (checker ? " checker" : ""),
      ref: r => {
        this.el = r;
      },
      onMouseDown: this.down,
      onMouseMove: this.move,
      onMouseUp: this.up,
      onMouseLeave: this.up
    }, /*#__PURE__*/React.createElement("img", {
      src: src,
      alt: "",
      draggable: false,
      ref: r => {
        this.img = r;
      }
    }), live && live.w > 0 && /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-rect",
      style: {
        left: `${live.x * 100}%`,
        top: `${live.y * 100}%`,
        width: `${live.w * 100}%`,
        height: `${live.h * 100}%`
      }
    })));
  }
}

/** Edit Mode: tools on the right, the image on the left, versions along the bottom. */
export class EditModeModal extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      family: undefined,
      currentId: null,
      tool: "prompt_edit",
      rect: null,
      prompt: "",
      bgMode: "transparent",
      bgHex: "#ffffff",
      aspect: "1:1",
      flipMode: "horizontal",
      degrees: 90,
      busy: false,
      step: "",
      history: undefined,
      products: [],
      brand: null,
      attribute: "",
      target: "",
      swatchUrl: "",
      scene: "",
      views: new Set(["front", "back", "side", "detail"]),
      packMode: "white",
      position: "bottom_right",
      badgeText: "SALE",
      qa: null
    });
    _defineProperty(this, "_alive", true);
    _defineProperty(this, "onKey", e => {
      if (e.key === "Escape" && !this.state.busy) this.props.onClose();
    });
    _defineProperty(this, "load", async selectId => {
      const a = await resolveAsset(this.props.asset);
      if (!a) {
        toast("Could not open this asset.");
        this.props.onClose();
        return;
      }
      const d = await safe(svc(`/content/assets/${String(a.id)}/versions`).getAsync(), {
        items: [a]
      });
      const family = d && d.items && d.items.length ? d.items : [a];
      const latest = family[family.length - 1];
      const h = await safe(svc(`/content/assets/${String(a.id)}/edits`).getAsync(), {
        items: []
      });
      if (this._alive) this.setState({
        family,
        currentId: String(selectId || (this.state.currentId && family.some(v => String(v.id) === String(this.state.currentId)) ? this.state.currentId : latest.id)),
        history: h && h.items || []
      });
      if (this.state.products.length === 0 && !this._productLoaded) {
        this._productLoaded = true;
        const pc = await safe(svc(`/content/assets/${String(a.id)}/product`).getAsync(), null);
        const kit = await loadBrandKit();
        const products = pc && pc.products || [];
        const brand = {
          ...(kit || {}),
          ...(pc && pc.brand || {})
        };
        const first = products[0];
        const keys = first ? Object.keys(first.options || {}) : [];
        if (this._alive) this.setState({
          products,
          brand,
          attribute: keys[0] || "",
          target: ""
        });
      }
    });
    _defineProperty(this, "liftKeep", false);
    _defineProperty(this, "apply", async () => {
      if (!this.canApply()) return;
      const cur = this.current();
      const p = this.params();
      const ai = this.isAI();
      const sourceId = String(cur.id);
      this.setState({
        busy: true,
        step: ai ? "Sending to the image agent…" : "Working…",
        qa: null
      });
      let runId = null;
      try {
        const r = await this.props.runAgent(this.agentFor(), p.prompt || `${p.action} the image`, p);
        runId = r && (r.runId || r.id || r.agentRunId || r.Id);
        if (this._alive) this.setState({
          step: ai ? "Editing with AI…" : "Applying…"
        });
        const done = await this.props.waitAgent(runId, 4000, 90);
        const ctx = done && done.ctx || {};
        const res = done && done.res || {};
        const multi = Array.isArray(ctx.results) ? ctx.results : Array.isArray(res.results) ? res.results : null;
        if (done.ok && multi && multi.length && p.action === "view_pack") {
          const batchId = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : String(Date.now());
          let last = null;
          for (let i = 0; i < multi.length; i++) {
            const x = multi[i];
            if (!x || !x.url) continue;
            const saved = await safe(svc(`/content/assets/${sourceId}/edits`).postAsync({
              action: "view_pack",
              params: JSON.stringify({
                ...p,
                view: x.label
              }),
              status: "done",
              url: x.url,
              width: x.width || null,
              height: x.height || null,
              label: `View ${x.label || i + 1}`,
              credits: i === 0 ? AI_CREDITS : 0,
              batchId
            }), null);
            if (saved && saved.version) last = saved.version;
          }
          toast(`${multi.length} view${multi.length === 1 ? "" : "s"} saved as versions.`);
          if (this.props.onSaved && last) this.props.onSaved(last, this.root());
          await this.load(last ? last.id : null);
          return;
        }
        const url = ctx.outputUrl || res.outputUrl || ctx.urls && ctx.urls[0] || res.urls && res.urls[0];
        if (!done.ok || !url) {
          const err = done && done.timeout ? "Still working: the version will appear in Assets when it finishes." : "The edit did not produce an image.";
          await safe(svc(`/content/assets/${sourceId}/edits`).postAsync({
            action: p.action,
            prompt: p.prompt || null,
            params: JSON.stringify(p),
            status: "failed",
            error: err,
            credits: ai ? AI_CREDITS : 0
          }), null);
          toast(err);
          return;
        }
        const saved = await safe(svc(`/content/assets/${sourceId}/edits`).postAsync({
          action: p.action,
          prompt: p.prompt || null,
          params: JSON.stringify(p),
          status: "done",
          url,
          width: ctx.width || res.width || null,
          height: ctx.height || res.height || null,
          label: this.labelFor(),
          credits: ai ? AI_CREDITS : 0
        }), null);
        const v = saved && saved.version;
        toast(v ? `Saved as v${v.version}.` : "Edit saved.");
        if (this.props.onSaved && v) this.props.onSaved(v, this.root());
        await this.load(v ? v.id : null);
        if (this._alive) this.setState({
          rect: null,
          prompt: this.state.tool === "prompt_edit" ? "" : this.state.prompt
        });
      } catch (e) {
        if (this.props.creditsToast) this.props.creditsToast(e, "Could not start the edit.");else toast(e && e.message || "Could not start the edit.");
      } finally {
        if (this._alive) this.setState({
          busy: false,
          step: ""
        });
      }
    });
    // Tier 2 QA: content_edit_qa_agent looks at the current version and says ready / needs a look (free).
    _defineProperty(this, "checkQa", async () => {
      const cur = this.current();
      const root = this.root();
      if (!cur) return;
      this.setState({
        qa: {
          busy: true
        }
      });
      try {
        const r = await this.props.runAgent("content_edit_qa_agent", "Check this edited image", {
          imageUrl: cur.url,
          originalUrl: root && root.url !== cur.url ? root.url : undefined,
          action: (cur.title || "").split(" · ").pop()
        });
        const done = await this.props.waitAgent(r && (r.runId || r.id || r.agentRunId || r.Id), 4000, 30);
        let verdict = null;
        try {
          const raw = done && done.res && (done.res.ready !== undefined ? done.res : null) || null;
          verdict = raw || JSON.parse(String(done && done.run && (done.run.runResult || done.run.RunResult) || "{}").replace(/^[^{]*/, "").replace(/[^}]*$/, ""));
        } catch (e) {
          verdict = null;
        }
        if (this._alive) this.setState({
          qa: verdict ? {
            ready: !!verdict.ready,
            issues: verdict.issues || [],
            summary: verdict.summary || ""
          } : {
            ready: null,
            summary: done && done.timeout ? "Still checking: try again in a minute." : "The check did not return a verdict."
          }
        });
      } catch (e) {
        if (this._alive) this.setState({
          qa: {
            ready: null,
            summary: e && e.message || "Could not run the check."
          }
        });
      }
    });
  }
  componentDidMount() {
    this.load();
    document.addEventListener("keydown", this.onKey);
  }
  componentWillUnmount() {
    this._alive = false;
    document.removeEventListener("keydown", this.onKey);
  }
  current() {
    const f = this.state.family || [];
    return f.find(v => String(v.id) === String(this.state.currentId)) || f[f.length - 1];
  }
  root() {
    const f = this.state.family || [];
    return f[0];
  }
  needsRect() {
    return this.state.tool === "erase" || this.state.tool === "crop";
  }
  isAI() {
    return !MECHANICAL.has(this.state.tool);
  }
  canApply() {
    const {
      tool,
      rect,
      prompt,
      busy,
      target,
      views,
      brand,
      badgeText
    } = this.state;
    if (busy || !this.current()) return false;
    if (tool === "prompt_edit") return prompt.trim().length > 2;
    if (this.needsRect()) return !!rect;
    if (tool === "variant_swap") return (target || "").trim().length > 0;
    if (tool === "view_pack") return views.size > 0;
    if (tool === "overlay_logo") return !!(brand && brand.logoUrl);
    if (tool === "brand_background") return !!(brand && brand.accent);
    if (tool === "badge") return (badgeText || "").trim().length > 0;
    return true;
  }
  agentFor() {
    return PRODUCT_ACTIONS.has(this.state.tool) ? "content_product_edit_agent" : "content_image_edit_agent";
  }
  params() {
    const {
      tool,
      rect,
      prompt,
      bgMode,
      bgHex,
      aspect,
      flipMode,
      degrees
    } = this.state;
    const cur = this.current();
    const p = {
      imageUrl: cur.url,
      action: tool
    };
    if (tool === "prompt_edit") {
      p.prompt = prompt.trim();
      if (rect) p.rect = JSON.stringify(rect);
    }
    if (tool === "erase" || tool === "crop") p.rect = JSON.stringify(rect);
    if (tool === "remove_background") p.mode = bgMode === "hex" ? bgHex : bgMode;
    if (tool === "extend") {
      p.aspectRatio = aspect;
      if (prompt.trim()) p.prompt = prompt.trim();
    }
    if (tool === "upscale") p.factor = "2";
    if (tool === "flip") p.mode = flipMode;
    if (tool === "rotate") p.degrees = String(degrees);
    if (tool === "lift_subject") {
      if (rect) p.target = JSON.stringify(rect);
      p.keepOriginal = this.state.liftKeep ? "true" : "false";
      p.flip = this.state.liftFlip ? "true" : "false";
    }
    const {
      products,
      brand,
      attribute,
      target,
      swatchUrl,
      scene,
      views,
      packMode,
      position,
      badgeText
    } = this.state;
    if (PRODUCT_ACTIONS.has(tool)) {
      const pr = products[0] || {};
      p.title = pr.title || cur.title || "";
      p.productType = pr.productType || "";
      p.category = pr.category || "";
      p.options = JSON.stringify(pr.options || {});
      if (tool === "variant_swap") {
        p.attribute = attribute || "Variant";
        p.target = target.trim();
        if (swatchUrl.trim()) p.swatchUrl = swatchUrl.trim();
      }
      if (tool === "place_in_context") {
        if (scene) p.scene = scene;
        if (prompt.trim()) p.prompt = prompt.trim();
      }
      if (tool === "view_pack") {
        p.views = JSON.stringify(Array.from(views));
        p.count = String(views.size);
      }
      if (tool === "packshot") p.mode = packMode === "brand" && brand && brand.accent ? brand.accent : "white";
    }
    if (tool === "overlay_logo") {
      p.logoUrl = brand.logoUrl;
      p.position = position;
      p.scale = "0.18";
    }
    if (tool === "brand_background") p.mode = brand.accent;
    if (tool === "badge") {
      p.text = badgeText.trim();
      p.bgHex = brand && brand.accent || "#ff6358";
      p.textHex = "#ffffff";
      p.position = position;
    }
    return p;
  }
  allTools() {
    return [...TOOLS, ...PRODUCT_TOOLS, ...BRAND_TOOLS];
  }
  labelFor() {
    const {
      tool,
      bgMode,
      aspect,
      flipMode,
      degrees,
      prompt,
      attribute,
      target,
      scene,
      packMode,
      badgeText
    } = this.state;
    const t = this.allTools().find(x => x[0] === tool);
    const name = t ? t[1] : tool;
    if (tool === "variant_swap") return `${attribute || "Variant"}: ${target.trim()}`.slice(0, 48);
    if (tool === "place_in_context") return `In context${scene ? " · " + scene.replace(/_/g, " ") : ""}`;
    if (tool === "packshot") return `Packshot ${packMode === "brand" ? "brand" : "white"}`;
    if (tool === "badge") return `Badge ${badgeText.trim()}`.slice(0, 48);
    if (tool === "overlay_logo") return "Logo";
    if (tool === "brand_background") return "Brand background";
    if (tool === "prompt_edit") return prompt.trim().slice(0, 48);
    if (tool === "remove_background") return `${name} (${bgMode === "hex" ? "color" : bgMode})`;
    if (tool === "extend") return `${name} to ${aspect}`;
    if (tool === "flip") return `${name} ${flipMode}`;
    if (tool === "rotate") return `${name} ${degrees}°`;
    if (tool === "upscale") return `${name} 2x`;
    if (tool === "lift_subject") return this.state.liftKeep ? "Duplicate subject" : "Lift subject";
    return name;
  }
  render() {
    const {
      family,
      tool,
      rect,
      prompt,
      bgMode,
      bgHex,
      aspect,
      flipMode,
      degrees,
      busy,
      step,
      history,
      products,
      brand,
      attribute,
      target,
      swatchUrl,
      scene,
      views,
      packMode,
      position,
      badgeText,
      qa
    } = this.state;
    const cur = this.current();
    const root = this.root();
    const t = this.allTools().find(x => x[0] === tool) || TOOLS[0];
    const product = products[0];
    const optionKeys = product ? Object.keys(product.options || {}) : [];
    // SkiaSharp composites raster logos only: an .svg logo in the brand kit cannot be overlaid (upload a PNG).
    const logoIsSvg = !!(brand && brand.logoUrl && /\.svg(\?|$)/i.test(brand.logoUrl));
    const hasLogo = !!(brand && brand.logoUrl) && !logoIsSvg;
    const hasAccent = !!(brand && brand.accent);
    const ai = this.isAI();
    const stop = e => e.stopPropagation();
    return /*#__PURE__*/React.createElement("div", {
      className: "wa-modal-backdrop hub-edit-backdrop",
      onClick: () => {
        if (!busy) this.props.onClose();
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "wa-modal hub-edit-modal image",
      onClick: stop
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-head"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
      className: "hub-h3",
      style: {
        margin: 0
      }
    }, "Edit: ", root && root.title || "Image"), /*#__PURE__*/React.createElement("div", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, cur ? /*#__PURE__*/React.createElement(React.Fragment, null, "v", cur.version || 1, " of ", family ? family.length : 1, cur.width && cur.height ? ` · ${cur.width}×${cur.height}` : "", " \xB7 used in ", Number(root && root.usedCount || 0), " \xB7 source: ", sourceLabel(root && root.source)) : "Loading…")), /*#__PURE__*/React.createElement("span", {
      style: {
        display: "inline-flex",
        gap: 10,
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle sm",
      disabled: busy,
      onClick: this.props.onClose
    }, "Close"))), !family ? /*#__PURE__*/React.createElement("p", {
      className: "territory-hint"
    }, "Loading\u2026") : /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-stage"
    }, /*#__PURE__*/React.createElement(RectCanvas, {
      src: cur.url,
      rect: rect,
      enabled: tool === "prompt_edit" || tool === "erase" || tool === "crop" || tool === "lift_subject",
      checker: tool === "remove_background",
      onRect: r => this.setState({
        rect: r
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: "territory-hint hub-edit-stagehint"
    }, tool === "lift_subject" ? rect ? "Target set: the subject lands in the box. Drag again to change it." : "Drag a box where the subject should land, or leave it to recenter." : tool === "erase" || tool === "crop" ? rect ? "Box set. Drag again to change it." : "Drag a box on the image." : tool === "prompt_edit" ? rect ? "The change is limited to the box. Click once to clear it." : "Optional: drag a box to limit the change to one area." : t[2], busy && /*#__PURE__*/React.createElement("span", {
      className: "plk-chip info",
      style: {
        marginLeft: 8
      }
    }, step)), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-versions"
    }, family.slice().reverse().map(v => /*#__PURE__*/React.createElement("span", {
      key: String(v.id),
      style: {
        position: "relative",
        flex: "0 0 auto"
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "hub-edit-ver" + (String(v.id) === String(cur.id) ? " on" : ""),
      disabled: busy,
      title: v.title || "",
      onClick: () => this.setState({
        currentId: String(v.id),
        rect: null
      })
    }, /*#__PURE__*/React.createElement("img", {
      src: v.url,
      alt: "",
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, v.parentAssetId ? `v${v.version}` : "Original"), v.parentAssetId ? ` · ${(v.title || "").split(" · ").pop()}` : ` · ${sourceLabel(v.source)}`, /*#__PURE__*/React.createElement("i", null, fmtWhen(v.createdDate)))), v.parentAssetId ? /*#__PURE__*/React.createElement("button", {
      className: "hub-edit-ver-del",
      title: `Move v${v.version} to Trash (restore within 30 days)`,
      disabled: busy,
      onClick: async e => {
        e.stopPropagation();
        try {
          await svc(`/content/assets/${String(v.id)}?scope=version&replaceWithLatest=true`).deleteAsync();
          toast(`v${v.version} moved to Trash.`);
          await this.load();
          if (this.props.onSaved) this.props.onSaved(null, root);
        } catch (err) {
          toast(err && err.message || "Could not delete.");
        }
      }
    }, "\xD7") : null)))), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-tools"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-tools-scroll"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-grid"
    }, TOOLS.map(([k, name]) => /*#__PURE__*/React.createElement(Tile, {
      key: k,
      k: k,
      name: name,
      on: tool === k,
      off: busy,
      onClick: () => this.setState({
        tool: k,
        rect: k === "prompt_edit" ? rect : null
      })
    }))), product && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-group"
    }, "Product ", /*#__PURE__*/React.createElement("span", {
      className: "plk-chip"
    }, (product.title || "").slice(0, 32))), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-grid"
    }, PRODUCT_TOOLS.map(([k, name, hint]) => /*#__PURE__*/React.createElement(Tile, {
      key: k,
      k: k,
      name: name,
      title: k === "variant_swap" && optionKeys.length ? `${name}: from ${optionKeys.join(", ")}` : `${name}: ${hint}`,
      on: tool === k,
      off: busy,
      onClick: () => this.setState({
        tool: k,
        rect: null
      })
    })))), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-group"
    }, "Brand kit", logoIsSvg ? /*#__PURE__*/React.createElement("i", null, "logo needs a PNG (yours is SVG)") : !hasLogo && !hasAccent ? /*#__PURE__*/React.createElement("i", null, "set up under Settings, Brand kit") : null), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-grid"
    }, BRAND_TOOLS.map(([k, name, hint]) => {
      const off = k === "overlay_logo" && !hasLogo || k === "brand_background" && !hasAccent;
      return /*#__PURE__*/React.createElement(Tile, {
        key: k,
        k: k,
        name: name,
        title: off ? `${name}: needs the brand kit` : `${name}: ${hint}`,
        on: tool === k,
        off: busy || off,
        onClick: () => this.setState({
          tool: k,
          rect: null
        })
      });
    })), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-opts"
    }, tool === "variant_swap" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", null, "Option", /*#__PURE__*/React.createElement("select", {
      value: attribute,
      onChange: e => this.setState({
        attribute: e.target.value,
        target: ""
      })
    }, optionKeys.map(k => /*#__PURE__*/React.createElement("option", {
      key: k,
      value: k
    }, k)), !optionKeys.length && /*#__PURE__*/React.createElement("option", {
      value: "Variant"
    }, "Variant"))), attribute && product.options && product.options[attribute] && product.options[attribute].length ? /*#__PURE__*/React.createElement("label", null, "Value", /*#__PURE__*/React.createElement("select", {
      value: target,
      onChange: e => this.setState({
        target: e.target.value
      })
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "Pick a value"), product.options[attribute].map(v => /*#__PURE__*/React.createElement("option", {
      key: v,
      value: v
    }, v)), /*#__PURE__*/React.createElement("option", {
      value: "__custom"
    }, "Other\u2026"))) : null, (target === "__custom" || !(attribute && product.options && product.options[attribute] && product.options[attribute].length)) && /*#__PURE__*/React.createElement("input", {
      value: target === "__custom" ? "" : target,
      placeholder: `New ${attribute || "variant"} value, e.g. Navy, Oak, Linen Oat`,
      onChange: e => this.setState({
        target: e.target.value
      })
    }), /*#__PURE__*/React.createElement("input", {
      value: swatchUrl,
      placeholder: "Optional swatch or colorway image URL",
      onChange: e => this.setState({
        swatchUrl: e.target.value
      })
    })), tool === "place_in_context" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", null, "Scene", /*#__PURE__*/React.createElement("select", {
      value: scene,
      onChange: e => this.setState({
        scene: e.target.value
      })
    }, SCENES.map(([k, l]) => /*#__PURE__*/React.createElement("option", {
      key: k,
      value: k
    }, l)))), /*#__PURE__*/React.createElement("input", {
      value: prompt,
      placeholder: "Optional hint, e.g. morning light, clean surface",
      onChange: e => this.setState({
        prompt: e.target.value
      })
    })), tool === "view_pack" && /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-channels"
    }, VIEWS.map(([k, l]) => /*#__PURE__*/React.createElement("label", {
      key: k,
      className: views.has(k) ? "on" : ""
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: views.has(k),
      disabled: busy,
      onChange: () => {
        const n = new Set(views);
        if (n.has(k)) n.delete(k);else n.add(k);
        this.setState({
          views: n
        });
      }
    }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, l))))), tool === "packshot" && /*#__PURE__*/React.createElement("span", {
      className: "seg"
    }, [["white", "White"], ["brand", "Brand color"]].map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      className: packMode === k ? "on" : "",
      disabled: k === "brand" && !hasAccent,
      onClick: () => this.setState({
        packMode: k
      })
    }, l))), (tool === "overlay_logo" || tool === "badge") && /*#__PURE__*/React.createElement("label", null, "Position", /*#__PURE__*/React.createElement("select", {
      value: position,
      onChange: e => this.setState({
        position: e.target.value
      })
    }, POSITIONS.map(([k, l]) => /*#__PURE__*/React.createElement("option", {
      key: k,
      value: k
    }, l)))), tool === "badge" && /*#__PURE__*/React.createElement("input", {
      value: badgeText,
      maxLength: 24,
      placeholder: "SALE, NEW, -30%",
      onChange: e => this.setState({
        badgeText: e.target.value
      })
    }), tool === "overlay_logo" && hasLogo && /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: brand.logoUrl,
      alt: "",
      style: {
        height: 20,
        verticalAlign: "middle",
        marginRight: 6
      }
    }), "brand kit logo"), tool === "brand_background" && hasAccent && /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "inline-block",
        width: 14,
        height: 14,
        borderRadius: 3,
        background: brand.accent,
        verticalAlign: "middle",
        marginRight: 6
      }
    }), brand.accent), tool === "prompt_edit" && /*#__PURE__*/React.createElement("textarea", {
      rows: 3,
      value: prompt,
      placeholder: "e.g. \"Make the background a warm sunset\" or \"Turn the cushion navy\"",
      onChange: e => this.setState({
        prompt: e.target.value
      })
    }), tool === "extend" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", null, "New aspect", /*#__PURE__*/React.createElement("select", {
      value: aspect,
      onChange: e => this.setState({
        aspect: e.target.value
      })
    }, ASPECTS.map(([k, l]) => /*#__PURE__*/React.createElement("option", {
      key: k,
      value: k
    }, l)))), /*#__PURE__*/React.createElement("input", {
      value: prompt,
      placeholder: "Optional hint for the new edges, e.g. more sand and sky",
      onChange: e => this.setState({
        prompt: e.target.value
      })
    })), tool === "remove_background" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "seg"
    }, [["transparent", "Transparent"], ["white", "White"], ["hex", "Color"]].map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      className: bgMode === k ? "on" : "",
      onClick: () => this.setState({
        bgMode: k
      })
    }, l))), bgMode === "hex" && /*#__PURE__*/React.createElement("label", null, "Color", /*#__PURE__*/React.createElement("input", {
      type: "color",
      value: bgHex,
      onChange: e => this.setState({
        bgHex: e.target.value
      })
    }))), tool === "flip" && /*#__PURE__*/React.createElement("span", {
      className: "seg"
    }, [["horizontal", "Horizontal"], ["vertical", "Vertical"]].map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      className: flipMode === k ? "on" : "",
      onClick: () => this.setState({
        flipMode: k
      })
    }, l))), tool === "lift_subject" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: !!this.state.liftKeep,
      onChange: e => this.setState({
        liftKeep: e.target.checked
      }),
      style: {
        width: "auto"
      }
    }), " Keep the original (duplicate)"), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: !!this.state.liftFlip,
      onChange: e => this.setState({
        liftFlip: e.target.checked
      }),
      style: {
        width: "auto"
      }
    }), " Mirror the lifted subject")), tool === "rotate" && /*#__PURE__*/React.createElement("span", {
      className: "seg"
    }, [90, 180, 270].map(d => /*#__PURE__*/React.createElement("button", {
      key: d,
      className: degrees === d ? "on" : "",
      onClick: () => this.setState({
        degrees: d
      })
    }, d, "\xB0")))), cur && cur.parentAssetId ? /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-qa"
    }, /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle xs",
      disabled: busy || qa && qa.busy,
      onClick: this.checkQa
    }, qa && qa.busy ? "Checking…" : "Check this version"), qa && !qa.busy && (qa.ready === true ? /*#__PURE__*/React.createElement("span", {
      className: "plk-chip ok"
    }, "Ready") : qa.ready === false ? /*#__PURE__*/React.createElement("span", {
      className: "plk-chip warn"
    }, "Needs a look") : null), qa && !qa.busy && (qa.summary || (qa.issues || []).length > 0) && /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, qa.summary, (qa.issues || []).length ? " · " + qa.issues.join(" · ") : "")) : null, history && history.length > 0 && /*#__PURE__*/React.createElement("details", {
      className: "hub-edit-history"
    }, /*#__PURE__*/React.createElement("summary", null, "History (", history.length, ")"), history.slice(0, 12).map(j => /*#__PURE__*/React.createElement("div", {
      key: String(j.id),
      className: "territory-hint",
      style: {
        margin: "2px 0"
      }
    }, fmtWhen(j.createdDate), " \xB7 ", j.action, j.prompt ? ` · "${j.prompt.slice(0, 40)}"` : "", " \xB7 ", j.status, j.error ? ` · ${j.error.slice(0, 60)}` : "")))), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-commit"
    }, /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, "This edit: ", t[1], " \xB7 saved as v", family.length + 1), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      disabled: !this.canApply(),
      onClick: this.apply
    }, busy ? "Working…" : "Apply"))))));
  }
}

/** Smart Resize: one source to a channel set; the safe zone survives every crop. */
export class SmartResizeModal extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      asset: undefined,
      safe: null,
      fill: "extend",
      fillColor: "#ffffff",
      picked: new Set(["ig_square", "ig_portrait", "story"]),
      busy: false,
      step: "",
      results: null
    });
    _defineProperty(this, "_alive", true);
    _defineProperty(this, "onKey", e => {
      if (e.key === "Escape" && !this.state.busy) this.props.onClose();
    });
    _defineProperty(this, "load", async () => {
      const a = await resolveAsset(this.props.asset);
      if (!a) {
        toast("Could not open this asset.");
        this.props.onClose();
        return;
      }
      if (this._alive) this.setState({
        asset: a
      });
    });
    _defineProperty(this, "toggle", k => {
      const picked = new Set(this.state.picked);
      if (picked.has(k)) picked.delete(k);else picked.add(k);
      this.setState({
        picked
      });
    });
    _defineProperty(this, "run", async () => {
      const {
        asset,
        safe: safeRect,
        fill,
        fillColor,
        picked
      } = this.state;
      const targets = CHANNELS.filter(([k]) => picked.has(k)).map(([, label, width, height]) => ({
        label,
        width,
        height
      }));
      if (!targets.length || !asset) return;
      this.setState({
        busy: true,
        step: "Sending to the resize agent…",
        results: null
      });
      const batchId = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : String(Date.now());
      const p = {
        imageUrl: asset.url,
        targets: JSON.stringify(targets),
        fill,
        fillColor
      };
      if (safeRect) p.safe = JSON.stringify(safeRect);
      try {
        const r = await this.props.runAgent("content_resize_agent", `Resize to ${targets.length} channel sizes`, p);
        const runId = r && (r.runId || r.id || r.agentRunId || r.Id);
        if (this._alive) this.setState({
          step: `Resizing to ${targets.length} sizes…`
        });
        const done = await this.props.waitAgent(runId, 4000, 75);
        const ctx = done && done.ctx || {};
        const res = done && done.res || {};
        const results = ctx.results || res.results || [];
        if (!done.ok || !results.length) {
          const err = done && done.timeout ? "Still working: the sizes will appear in Assets when they finish." : "The resize did not produce any sizes.";
          await safe(svc(`/content/assets/${String(asset.id)}/edits`).postAsync({
            action: "smart_resize",
            params: JSON.stringify(p),
            status: "failed",
            error: err,
            credits: AI_CREDITS,
            batchId
          }), null);
          toast(err);
          return;
        }
        const saved = [];
        for (let i = 0; i < results.length; i++) {
          const x = results[i];
          const s = await safe(svc(`/content/assets/${String(asset.id)}/edits`).postAsync({
            action: "smart_resize",
            params: JSON.stringify({
              ...p,
              target: x.label
            }),
            status: "done",
            url: x.url,
            width: x.width,
            height: x.height,
            label: `${x.label} ${x.width}x${x.height}`,
            credits: i === 0 ? AI_CREDITS : 0,
            batchId
          }), null);
          saved.push({
            ...x,
            version: s && s.version
          });
        }
        if (this._alive) this.setState({
          results: saved
        });
        toast(`${saved.length} size${saved.length === 1 ? "" : "s"} saved as versions.`);
        if (this.props.onSaved) this.props.onSaved(saved.map(x => x.version).filter(Boolean), asset);
      } catch (e) {
        if (this.props.creditsToast) this.props.creditsToast(e, "Could not start the resize.");else toast(e && e.message || "Could not start the resize.");
      } finally {
        if (this._alive) this.setState({
          busy: false,
          step: ""
        });
      }
    });
  }
  componentDidMount() {
    this.load();
    document.addEventListener("keydown", this.onKey);
  }
  componentWillUnmount() {
    this._alive = false;
    document.removeEventListener("keydown", this.onKey);
  }
  render() {
    const {
      asset,
      safe: safeRect,
      fill,
      fillColor,
      picked,
      busy,
      step,
      results
    } = this.state;
    const n = picked.size;
    const stop = e => e.stopPropagation();
    return /*#__PURE__*/React.createElement("div", {
      className: "wa-modal-backdrop hub-edit-backdrop",
      onClick: () => {
        if (!busy) this.props.onClose();
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "wa-modal hub-edit-modal",
      onClick: stop
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-head"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
      className: "hub-h3",
      style: {
        margin: 0
      }
    }, "Resize: ", asset && asset.title || "Image"), /*#__PURE__*/React.createElement("div", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, asset ? /*#__PURE__*/React.createElement(React.Fragment, null, "Source", asset.width && asset.height ? ` ${asset.width}×${asset.height}` : "", " \xB7 v", asset.version || 1, " \xB7 ", sourceLabel(asset.source)) : "Loading…")), /*#__PURE__*/React.createElement("span", {
      style: {
        display: "inline-flex",
        gap: 10,
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle sm",
      disabled: busy,
      onClick: this.props.onClose
    }, "Close"))), !asset ? /*#__PURE__*/React.createElement("p", {
      className: "territory-hint"
    }, "Loading\u2026") : /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-stage"
    }, /*#__PURE__*/React.createElement(RectCanvas, {
      src: asset.url,
      rect: safeRect,
      enabled: !busy,
      onRect: r => this.setState({
        safe: r
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: "territory-hint hub-edit-stagehint"
    }, safeRect ? "Safe zone set: the product and any text inside it stay in every size. Drag again to change it." : "Drag a safe zone: the product and any text inside it stay in every size. Leave it empty to keep the center.", busy && /*#__PURE__*/React.createElement("span", {
      className: "plk-chip info",
      style: {
        marginLeft: 8
      }
    }, step)), results && /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-versions"
    }, results.map((x, i) => /*#__PURE__*/React.createElement("a", {
      key: i,
      className: "hub-edit-ver on",
      href: x.url,
      target: "_blank",
      rel: "noreferrer",
      title: x.label
    }, /*#__PURE__*/React.createElement("img", {
      src: x.url,
      alt: ""
    }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, x.label), " \xB7 ", x.width, "\xD7", x.height, /*#__PURE__*/React.createElement("i", null, x.usedAI ? "extended" : "cropped")))))), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-tools"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-opts",
      style: {
        marginTop: 0
      }
    }, /*#__PURE__*/React.createElement("b", {
      style: {
        fontSize: 12
      }
    }, "Fill edges by"), /*#__PURE__*/React.createElement("span", {
      className: "seg"
    }, [["extend", "Extend scene"], ["blur", "Blur fill"], ["color", "Color"]].map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      className: fill === k ? "on" : "",
      disabled: busy,
      onClick: () => this.setState({
        fill: k
      })
    }, l))), fill === "color" && /*#__PURE__*/React.createElement("label", null, "Color", /*#__PURE__*/React.createElement("input", {
      type: "color",
      value: fillColor,
      onChange: e => this.setState({
        fillColor: e.target.value
      })
    })), /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, "Extend uses AI where a size needs more picture. Blur and color never do.")), /*#__PURE__*/React.createElement("b", {
      style: {
        fontSize: 12,
        display: "block",
        marginTop: 12,
        marginBottom: 6
      }
    }, "Channels"), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-channels"
    }, CHANNELS.map(([k, label, w, h]) => /*#__PURE__*/React.createElement("label", {
      key: k,
      className: picked.has(k) ? "on" : ""
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: picked.has(k),
      disabled: busy,
      onChange: () => this.toggle(k)
    }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, label), /*#__PURE__*/React.createElement("i", null, w, "\xD7", h))))), /*#__PURE__*/React.createElement("div", {
      className: "hub-edit-commit"
    }, /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, n, " size", n === 1 ? "" : "s", " \xB7 each saved as a version"), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      disabled: busy || !n,
      onClick: this.run
    }, busy ? "Working…" : "Create set"))))));
  }
}